<template>
  <!-- <div
    class="py-1 rounded-[20px] center-content text-sm font-medium"
    :class="{
      'bg-estationsGreen-100 text-estationsGreen-700': theme == 'Success',
      'bg-red-100 text-red-500': theme == 'Failed',
    }"
  >
    {{ statusText }}
  </div> -->

  <p class="px-4 py-1 rounded-full w-fit" :class="theme">
    {{ salesType }}
  </p>
</template>

<script>
export default {
  props: {
    salesType: {
      type: String,
      required: true,
      default: "",
    },
  },
  computed: {
    theme() {
      const salesType = this.salesType.trim().toLowerCase();

      if (
        salesType === "voucher" ||
        salesType === "partial" ||
        salesType === "partially_processed"
      ) {
        return "text-purple-500 bg-purple-50";
      } else if (salesType === "retainership" || salesType === "draft") {
        return "bg-brown-50 text-brown-500";
      } else if (salesType === "remis") {
        return "bg-blue-50 text-blue-500";
      } else if (
        salesType === "ussd" ||
        salesType === "part paid" ||
        salesType === "due for payment" ||
        salesType === "pending" ||
        salesType === "processing"
      ) {
        return "bg-yellow-50 text-yellow-500";
      } else if (
        salesType === "debit" ||
        salesType === "overdue" ||
        salesType === "due" ||
        salesType === "vendor declined" ||
        salesType === "maintenance declined" ||
        salesType === "closed" ||
        salesType === "inactive" ||
        salesType === "failed" ||
        salesType === "blocked"
      ) {
        return "bg-red-50 text-red-500";
      } else if (
        salesType === "approved" ||
        salesType === "fulfilled" ||
        salesType === "vendor engaged" ||
        salesType === "vendor accepted" ||
        salesType === "active" ||
        salesType === "completed" ||
        salesType === "in progress"
      ) {
        return "bg-estationsGreen-50 text-estationsGreen-500";
      } else {
        return "bg-estationsGreen-50 text-estationsGreen-500";
      }
    },
  },
};
</script>

<style></style>
